import { forEach, orderBy } from 'lodash';

import CoreUtils from '../../common/utils/CoreUtils';

import EnergyValue from '../../common/value-types/EnergyValue';
import MetadataHelper from '../../common/value-types/MetadataHelper';

import ScheduleDataModel from '../../schedules/ScheduleDataModel';

export default class FlexHoursDataModel extends ScheduleDataModel {
  constructor(locale, counterparty, commandDataModel, summaryDataModel) {
    super(locale, counterparty, commandDataModel)

    this.summaryDataModel = summaryDataModel;

    this.monthDayCount = 0;
    this.enableDirectEntry = false;
    this.activateDirectEntry = false;
  }

  processFullServerUpdate(scheduleUpdateDto) {
    this.monthDayCount = scheduleUpdateDto.monthDayCount;
    this.enableDirectEntry = scheduleUpdateDto.enableDirectEntry;

    super.processFullServerUpdate(scheduleUpdateDto);
  }

  processContracts(scheduleUpdateDto) {
    forEach(scheduleUpdateDto.contracts, contractDto => {
      var flexHoursPerDay = parseInt(contractDto.parameters.FlexHoursPerDay);
      var flexHoursPerMonth = flexHoursPerDay * this.monthDayCount;

      var contract = {};
      Object.assign(contract, contractDto);

      contract.flexAvailableH = flexHoursPerMonth;
      contract.flexAvailableMWh = contractDto.hourlyEnergyMaximum * flexHoursPerMonth;
      contract.flexTakenH = 0;
      contract.flexTakenMWh = 0;
      contract.flexRemainingH = 0;
      contract.flexRemainingMWh = 0;

      this.registerContract(contract);
    });
  }

  getDefaultSortCriteria() {
    return {
      fields: ['localDateMs', 'contractCode'],
      order: ['asc', 'asc']
    };
  }

  updateOverallStatus() {
    super.updateOverallStatus();

    CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
      contract.flexTakenMWh = 0;
      contract.flexRemainingMWh = contract.flexAvailableMWh;
      contract.flexTakenH = 0;
      contract.flexRemainingH = contract.flexAvailableH;
    });

    var isAllocationExceeded = false;

    CoreUtils.iterateProperties(this.indexedSchedules, (_, schedule) => {
      var contract = this.indexedContracts[schedule.contractCode];
      if (contract === undefined)
        return;

      contract.flexTakenMWh += schedule.flexTakenMWh;
      contract.flexRemainingMWh -= schedule.flexTakenMWh;
      contract.flexTakenH += schedule.flexTakenH;
      contract.flexRemainingH -= schedule.flexTakenH;

      contract.isAllocationExceeded = contract.flexRemainingMWh < 0;
    });

    if (CoreUtils.isDefinedAndNotNull(this.summaryDataModel)) {
      var contracts = [];
      CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
        if (contract.enableViewValues) {
          if (contract.isAllocationExceeded)
            isAllocationExceeded = true;

          contracts.push(contract);
        }
      });

      this.summaryDataModel.updateProperties({
        contracts: orderBy(contracts, ['code'], ['asc']),
        isAllocationExceeded: isAllocationExceeded
      });
    }

    this.hasValidationErrors = isAllocationExceeded;

    if (CoreUtils.isDefinedAndNotNull(this.commandDataModel)) {
      this.commandDataModel.updateProperties({
        hasValidationErrors: this.hasValidationErrors
      });
    }
  }

  canEditFieldValue(schedule, dataField) {
    if (!super.canEditFieldValue(schedule, dataField))
      return false;

    return this.enableDirectEntry && this.activateDirectEntry;
  }

  onFieldValuesEditing(schedule, dataFieldValues) {
    if (!super.onFieldValuesEditing(schedule, dataFieldValues))
      return false;

    return this.filterUpdatingElectableHourFields(
      schedule,
      dataFieldValues,
      this.indexedContracts[schedule.contractCode]
    );
  }

  updateScheduleUsage(schedule, updatedDataFields) {
    super.updateScheduleUsage(schedule, updatedDataFields);

    var totalMWh = 0;
    var totalH = 0;
    var flexTakenMWh = 0;
    var flexTakenH = 0;

    forEach(
      schedule.hourlyDataFields, dataField => {
        var metadataField = MetadataHelper.resolveMetadataField(dataField);
        var energyMWh = schedule[dataField].averageValue;
        var energyH = schedule[dataField].averageDuration;

        totalMWh += energyMWh;
        totalH += energyH;

        if (schedule[metadataField].isElectableHour) {
          flexTakenMWh += energyMWh;
          flexTakenH += energyH;
        }
      }
    );

    if (totalMWh !== schedule.totalMWh) {
      schedule.totalMWh = totalMWh;
      updatedDataFields.push('totalMWh');
    }

    if (totalH !== schedule.totalH) {
      schedule.totalH = totalH;
      updatedDataFields.push('totalH');
    }

    if (flexTakenMWh !== schedule.flexTakenMWh) {
      schedule.flexTakenMWh = flexTakenMWh;
      updatedDataFields.push('flexTakenMWh');
    }

    if (flexTakenH !== schedule.flexTakenH) {
      schedule.flexTakenH = flexTakenH;
      updatedDataFields.push('flexTakenH');
    }
  }

  setActivateDirectEntry(activate) {
    this.activateDirectEntry = activate;
  }

  toggleFlexEnergyValues(scheduleDataFieldSets, addFlexHours) {
    var scheduleUpdateSets = [];
    scheduleDataFieldSets.forEach(scheduleDataFieldSet => {
      var schedule = this.indexedSchedules[scheduleDataFieldSet.scheduleId];
      if (CoreUtils.isUndefinedOrNull(schedule))
        return;

      var updatedDataFields = scheduleDataFieldSet.dataFields.filter(
        dataField => schedule.hourlyDataFields.indexOf(dataField) !== -1
      );

      var flexValue = new EnergyValue(
        addFlexHours
          ? this.indexedContracts[schedule.contractCode].hourlyEnergyMaximum
          : this.indexedContracts[schedule.contractCode].hourlyEnergyMinimum
      );

      updatedDataFields = updatedDataFields.filter(
        dataField => !schedule[dataField].equals(flexValue)
          && this.canModifyFieldValue(schedule, dataField)
      );

      scheduleUpdateSets.push(
        this.generateSingleValueScheduleUpdateSet(
          schedule.scheduleId,
          updatedDataFields,
          flexValue
        )
      );
    });

    return this.updateSchedules(scheduleUpdateSets, false);
  }
}